import React from 'react';
import classnames from 'classnames';
import { Case, Default, Switch } from 'react-if';

import { Tooltip } from '@nerdwallet/currency/components/Tooltip';
import Help from '@nerdwallet/react-icon/nerdwallet-ui/Help';

import styles from './beta-tag.module.scss';

interface Props {
  tooltipContent?: React.ReactNode;
  className?: string;
}

const BetaTag: React.FC<Props> = ({ tooltipContent, className }) => {
  return (
    <Switch>
      <Case condition={!!tooltipContent}>
        <div className={styles.betaPopupDialog}>
          <Tooltip content={tooltipContent}>
            <div className={classnames(styles.beta, className)}>
              BETA
              <div className={styles.betaTooltip}>
                <Help />
              </div>
            </div>
          </Tooltip>
        </div>
      </Case>
      <Default>
        <div className={classnames(styles.beta, className)}>BETA</div>
      </Default>
    </Switch>
  );
};

export default BetaTag;
